export default function BackButton(href, fallbackPath) {
  const referrer = window.location.origin
  const referrerHostname = referrer ? new URL(referrer).hostname : null
  if (href) {
    location.href = href
  } else if (referrerHostname?.endsWith(window.location.hostname)) {
    window.history.back()
  } else {
    location.href = fallbackPath
  }
}
